var map = {
	"./da.png": "7caf",
	"./de.png": "e489",
	"./en.png": "d615",
	"./fi.png": "6dbc",
	"./fr.png": "2176",
	"./hr.png": "e5b0",
	"./it.png": "e9d6",
	"./mn.png": "4b1d",
	"./ne.png": "0abf",
	"./nl.png": "653a",
	"./no.png": "1d51",
	"./sv.png": "a460",
	"./th.png": "151e",
	"./ur.png": "b815",
	"./vi.png": "2e0c",
	"./zh.png": "91bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61f4";